import { render, staticRenderFns } from "./StaffInboxOnReferenceObjects.vue?vue&type=template&id=7f1eb80d&scoped=true&"
import script from "./StaffInboxOnReferenceObjects.vue?vue&type=script&lang=ts&"
export * from "./StaffInboxOnReferenceObjects.vue?vue&type=script&lang=ts&"
import style0 from "./StaffInboxOnReferenceObjects.vue?vue&type=style&index=0&id=7f1eb80d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1eb80d",
  null
  
)

export default component.exports